<template>
  <v-card>
    <v-card-title>
      <span class="headline">{{
        editar ? "Editar producto" : "Nuevo producto"
      }}</span>
    </v-card-title>

    <v-card-text>
      <v-alert v-model="mostrar_alert" dismissible :type="type_alert">
        <template v-html="html_alert" />
      </v-alert>

      <v-container grid-list-md>
        <v-row>
          <v-col xs="12" sm="6">
            <v-col xs="12">
              <v-text-field
                v-model="form.nombre"
                :error-messages="error_input.nombre"
                label="Nombre"
              />
            </v-col>
            <v-col xs="12">
              <v-text-field
                v-model="form.unidad_medida"
                :error-messages="error_input.unidad_medida"
                label="Unidad de medida"
                placeholder="Kg, g, L, pza, etc."
                hint=""
              />
            </v-col>
            <v-col xs="12">
              <v-text-field
                v-model="form.order"
                type="number"
                step="1"
                hint="Este valor indicar el orden que deben tomar los productos cuando se listan en la APP, si se omite se ordenan por la fecha de registro"
                :error-messages="error_input.order"
                label="Orden"
              />
            </v-col>
            <v-col xs="12">
              <v-textarea
                v-model="form.descripcion"
                :error-messages="error_input.descripcion"
                label="Descripción"
              />
            </v-col>
            <v-col xs="6">
              <v-card>
                <div class="d-flex flex-no-wrap justify-space-between">
                  <div>
                    <v-card-text>
                      <ul>
                        <li>
                          Solo se aceptan archivos <b>PNG</b> o <b>JPG</b>
                        </li>
                        <li>
                          Debe estar optimizada para web, no deberían pesar mas
                          de <b class="red--text">500kB</b>
                        </li>
                        <li>
                          Se recomienda que la imagen tenga medidas de
                          <b>200*200px</b>, para que en las diferentes pantallas
                          se pueda apreciar mejor su diseño
                        </li>
                      </ul>
                    </v-card-text>
                  </div>

                  <v-avatar class="ma-3" size="90" tile>
                    <v-img
                      :lazy-src="$root.IMAGE_LAZY"
                      :src="imageSrc"
                      class="white--text align-end"
                      height="90px"
                      width="90px"
                    >
                    </v-img>
                  </v-avatar>
                </div>
              </v-card>
              <v-file-input
                @change="onFileChange"
                label="Elige un archivo"
                placeholder="Clic para elegir"
                accept="image/png, image/jpeg"
                show-size
                :rules="rules_image"
              ></v-file-input>
            </v-col>
            <v-col xs="6" sm="6">
              <v-switch v-model="form.activo" label="Mostrar en APP" />
            </v-col>
            <v-col xs="6" sm="6">
              <v-switch v-model="form.es_promocion" label="Es Promoción" />
            </v-col>
          </v-col>
          <v-col xs="12" sm="6">
            <v-flex xs12 d-flex>
              <v-autocomplete
                v-model="form.familia_id"
                :items="familias"
                item-text="nombre"
                item-value="id"
                :loading="loading_familia"
                label="Categoría"
                @change="listarSubFamilias()"
              />
            </v-flex>
            <v-flex xs12 d-flex>
              <v-autocomplete
                v-model="form.subfamilia_id"
                :items="subfamilias"
                item-text="nombre"
                item-value="id"
                :loading="loading_subfamilia"
                label="Sub-Categoría"
              />
            </v-flex>
            <v-flex xs12>
              <v-text-field
                v-for="(item_precio, index) in form.precios"
                :key="index + '-precio'"
                v-model.number="item_precio.precio"
                :label="'Precio: ' + item_precio.nombre"
              />
              <p v-if="error_input.precios" class="error--text">
                {{ error_input.precios.join(",") }}
              </p>
            </v-flex>
          </v-col>
        </v-row>
        <v-row v-if="form.es_promocion">
          <FormSaleSchedule
            :producto_id="form.id"
            :promocion="form.horario_promocion"
            ref="promocion"
            @save="$emit('save', '')"
          />
        </v-row>
      </v-container>
    </v-card-text>

    <v-card-actions>
      <v-spacer />
      <v-btn color="gray darken-1" @click="close"> Cancelar </v-btn>
      <v-btn
        color="blue darken-1"
        class="white--text"
        :loading="loading"
        :disabled="loading"
        @click="guardar"
      >
        Guardar
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import axios from "axios";
import EventBus from "../EventBus";
import FormSaleSchedule from "@components/FormSaleSchedule";

export default {
  name: "FormProducto",
  components: {
    FormSaleSchedule,
  },
  props: {
    idItem: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      form: {
        id: 0,
        nombre: "",
        image: null,
        image_name: null,
        descripcion: "",
        unidad_medida: "",
        activo: true,
        order: null,
        familia_id: null,
        subfamilia_id: null,
        precios: [],
        es_promocion: false,
      },
      error_input: {
        nombre: "",
      },
      loading: false,
      loading_producto: false,
      loading_subfamilia: false,
      mostrar_alert: false,
      type_alert: "success",
      html_alert: "",
      familias: [],
      subfamilias: [],
      loading_familia: false,
      tipo_precios: [],
      loading_tipo_precios: false,
      rules_image: [
        (value) => {
          return (
            !value ||
            value.size < 500000 ||
            "Te recomendamos que la imagen sea menor a 500kb"
          );
        },
      ],
    };
  },
  computed: {
    editar() {
      return this.idItem > 0;
    },
    imageSrc() {
      return this.form.image ? this.form.image : this.form.imagen_url;
    },
  },
  watch: {},
  mounted() {
    this.listarFamilias();
    this.verProducto();
  },
  methods: {
    close() {
      this.form.id = 0;
      this.form.nombre = "";
      this.$emit("close", true);
    },
    guardar() {
      if (0 == this.form.subfamilia_id) {
        delete this.form.subfamilia_id;
      }

      let url_target = this.editar
        ? "/api/productos/actualizar/" + this.idItem
        : "/api/productos/guardar";
      this.loading = true;
      this.error_input.nombre = "";

      axios
        .post(url_target, this.form)
        .then((success) => {
          let { data } = success;
          this.loading = false;
          /*window.console.log('IsData', data);*/
          if (data.success) {
            EventBus.$emit("tugarrafon:show-snackbar", {
              color: "success",
              text_content: data.message,
            });
            this.form.id = data.data.id;
            if (this.form.es_promocion) {
              this.$refs.promocion.saveHorario();
            } else {
              this.form.nombre = "";
              this.$emit("save", data.message);
            }
          }
        })
        .catch((error) => {
          this.loading = false;
          if (error.response) {
            // The request was made and the server responded with a status code
            // that falls out of the range of 2xx
            /*window.console.log(error.response.data);
                            window.console.log(error.response.status);
                            window.console.log(error.response.headers);
                            window.console.info("Es error");*/
            EventBus.$emit("tugarrafon:show-snackbar", {
              color: "error",
              text_content: error.response.data.message,
            });
            if (error.response.status === 422) {
              /*window.console.info("Es error");
                                window.console.log(error.response.data.data);*/
              this.error_input = Object.assign({}, error.response.data.data);
            }
          } else if (error.request) {
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
            // http.ClientRequest in node.js
            /*window.console.log(error.request);*/
          } else {
            // Something happened in setting up the request that triggered an Error
            /*window.console.log('Error', error.message);*/
          }
        });
    },
    onFileChange(e) {
      let files = e;
      if (!files) {
        this.form.image = null;
        this.form.image_name = null;
        return;
      }
      this.createImage(files);
    },
    createImage(file) {
      let reader = new FileReader();
      let vm = this;
      reader.onload = (e) => {
        vm.form.image = e.srcElement.result;
      };
      (vm.form.image_name = file.name), reader.readAsDataURL(file);
    },
    verProducto() {
      if (this.idItem) {
        this.loading_producto = true;
        axios
          .get("/api/productos/ver/" + this.idItem)
          .then((response) => {
            this.loading_producto = false;
            let { data } = response;
            this.form = Object.assign(
              { image: null, image_name: null },
              data.data
            );
            this.listarTiposPrecios();
            this.listarSubFamilias();
          })
          .catch(() => {
            this.loading_producto = false;
          });
      } else {
        this.listarTiposPrecios();
      }
    },
    listarFamilias() {
      this.loading_familia = true;
      axios
        .get("/api/familia/listar", {
          params: {
            is_list: 1,
          },
        })
        .then((success) => {
          this.loading_familia = false;
          let { data } = success;
          this.familias = data;
          /*  if (this.editar === false) {
            this.form.familia_id = this.familias[0].id;
          } */
        })
        .catch(() => {
          this.loading_familia = false;
        });
    },
    listarSubFamilias() {
      this.loading_subfamilia = true;
      this.subfamilias = [];
      axios
        .get("/api/subfamilia/listar", {
          params: {
            is_list: 1,
            familia_id: this.form.familia_id,
          },
        })
        .then((success) => {
          this.loading_subfamilia = false;
          let { data } = success;
          this.subfamilias = data;
          /* if (this.editar === false) {
            this.form.subfamilia_id = this.subfamilias[0].id;
          } */
        })
        .catch(() => {
          this.loading_subfamilia = false;
        });
    },
    listarTiposPrecios() {
      this.loading_tipo_precios = true;
      axios
        .get("/api/tipo-precio/listar", {
          params: {
            is_list: 1,
          },
        })
        .then((success) => {
          this.loading_tipo_precios = false;
          let { data } = success;
          this.tipo_precios = data;
          this.procesarPrecios();
        })
        .catch(() => {
          this.loading_tipo_precios = false;
        });
    },
    procesarPrecios() {
      let new_precios = this.tipo_precios.map((item_tipo_precios) => {
        let precio = this.form.precios.find(
          (item) => item.tipo_precio_id === item_tipo_precios.id
        );

        if (precio) {
          return Object.assign({}, precio, { edit: true, delete: false });
        }

        return Object.assign(
          {},
          {
            id: 0,
            tipo_precio_id: item_tipo_precios.id,
            nombre: item_tipo_precios.nombre,
            precio: 0.0,
            edit: false,
            delete: false,
          }
        );
      });
      this.$set(this.form, "precios", new_precios);
    },
  },
};
</script>

<style scoped>
</style>
